import React from 'react';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { format } from 'date-fns';
import { useFetchDetalleDisponibilidadParcial } from '../../hooks/useFetchDetalleDisponibilidadParcial';
import { useFetchDetalleDisponibilidadParcialObjetivoDowntime } from '../../hooks/useFetchDetalleDisponibilidadParcialObjetivoDowntime';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Alert } from '@mui/material';
import { AvailabilityConsolidatedByStep } from '../../../../components/IndividualCharts/AvailiabilityConsolidated/AvailabilityConsolidatedByStep';
import { api_auth } from '../../../../common/globals/constants';

const URL_PARAMS = ({ objetivoId, periodo, nodoId }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('user', user);
  URL.append('key', api_auth);
  URL.append('token', token);
  URL.append('horarioId', '0');
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  URL.append('nodoId', nodoId);
  return URL;
};

export const AvailabilityConsolidatedByStepChart = React.memo(
  function AvailabilityConsolidatedByStepChart({ objetivoId, nodoId }) {
    const { filterPeriod, refreshTime } = useDynamicViewState();
    const {
      data: detalleDisponibilidadParcialData,
      isLoading: isLoadingDetalleDisponibilidadParcial,
      error: errorDetalleDisponibilidadParcial,
      isFetching: isFetchingDetalleDisponibilidadParcial,
    } = useFetchDetalleDisponibilidadParcial({
      urlParams: URL_PARAMS({
        objetivoId,
        periodo: filterPeriod,
        nodoId,
      }),
      fetchApi:
        filterPeriod.period === 'c'
          ? 'getDetalleDisponibilidadParcialObjetivoCustom'
          : 'getDetalleDisponibilidadParcialObjetivo',
      refreshTime,
    });
    const {
      data: detalleDisponibilidadParcialObjetivoDowntimeData,
      isLoading: isLoadingDetalleDisponibilidadParcialObjetivoDowntime,
      error: errorDetalleDisponibilidadParcialObjetivoDowntime,
      isFetching: isFetchingDetalleDisponibilidadParcialObjetivoDowntime,
    } = useFetchDetalleDisponibilidadParcialObjetivoDowntime({
      urlParams: URL_PARAMS({
        objetivoId,
        periodo: filterPeriod,
        nodoId,
      }),
      fetchApi:
        filterPeriod.period === 'c'
          ? 'getDetalleDisponibilidadParcialObjetivoDowntimeCustom'
          : 'getDetalleDisponibilidadParcialObjetivoDowntime',
      refreshTime,
    });

    const isLoading =
      isLoadingDetalleDisponibilidadParcial ||
      isLoadingDetalleDisponibilidadParcialObjetivoDowntime;
    const isFetching =
      isFetchingDetalleDisponibilidadParcial ||
      isFetchingDetalleDisponibilidadParcialObjetivoDowntime;
    const error =
      errorDetalleDisponibilidadParcial ||
      errorDetalleDisponibilidadParcialObjetivoDowntime;
    if (isLoading || isFetching) return <AtCircularProgress />;
    if (error)
      return <Alert severity="error">Error al cargar los datos.'</Alert>;

    return (
      <AvailabilityConsolidatedByStep
        dataConsolidated={detalleDisponibilidadParcialData}
        dataAvailabilityConsolidatedByStep={
          detalleDisponibilidadParcialObjetivoDowntimeData
        }
      />
    );
  }
);
